import MedicalSchoolLandingPage from './MedicalSchoolLandingPage';
export default MedicalSchoolLandingPage;
